<template>
    <div v-if="canShow('五脏风险评估') && info && tableList && tableList.length > 0">
        <div class="tips"></div>
        <div class="sick-box">
            <div class="risk">五脏风险评估</div>
        </div>
        <div class="assessment">
            <div class="table-mark">
                <table class="newre-table wuzang-table">
                    <thead>
                        <tr>
                            <th style="width: 30%;">五脏</th>
                            <th style="width: 35%;">评估分值</th>
                            <th style="width: 35%;">风险程度</th>
                        </tr>  
                    </thead>
                    <tbody>
                        <tr v-for="item in tableList" :key="item.sysName">
                            <td>{{ item.sysName }}</td>
                            <td class="score-text">{{ item.sysScore }}</td>
                            <td :class="getRiskClass(item.sysLevel)">{{ item.sysLevelDesc }}</td>
                        </tr>
                    </tbody>  
                </table>
            </div>

            <div class="wuzang-analysis">
                <div class="analysis-item" v-for="item in analysisList" :key="'analysis-' + item.sysName">
                    <div class="analysis-title">【{{ item.sysName }}：<span :class="getRiskClass(item.sysLevel)">{{ item.sysLevelDesc }}</span>】</div>
                    <div class="analysis-desc">
                        {{ item.sysDesc }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { moduleMixin } from '../helpers';
import { mapState } from 'vuex';

export default {
    name: 'ReportWuzangRisk',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info']),
        allZangfuList() {
            const info = this.info || {};
            const list = info.zangfu;
            if (!Array.isArray(list)) return [];
            return list;
        },
        tableList() {
            return this.allZangfuList.filter(item => item.sysName !== '五脏');
        },
        analysisList() {
            return this.allZangfuList.filter(item => !!item.sysDesc);
        }
    },
    methods: {
        getRiskClass(level) {
            if (level === 1) return 'risk-low';
            if (level === 2) return 'risk-medium';
            if (level === 3) return 'risk-high';
            return '';
        },
        getAnalysisDesc(item) {
            return item.sysDesc || '';
        }
    }
};
</script>

<style lang="scss" scoped>
@import './WuzangRisk.scss';
</style>
